import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import Slider from "react-slick";
import CircularDeterminate from "../_Components/CircularDeterminate"
import moment from 'moment';
import { Link } from 'react-router-dom';

export class LojaCliente extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      carrinho: [],
      buy : false,
      screenWidth: window.screen.width,
      statusVenda: false,
      clicked:  false,
      checkAll: false
    };
    // if( /Android|webOS|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    //   window.location.href = 'https://play.google.com/store/apps/details?id=com.bingo.sorteflash';
    // }
    this.statusVenda()
    this.cartelasLoja();
    this.selecionar = this.selecionar.bind(this);
    this.comprarPedido = this.comprarPedido.bind(this);
  }

  logout(){
    window.localStorage.setItem("rotaAtual", "");
    this.props.history.push('/')
}

  addCarrinho(index) {
    this.state.carrinho.push(this.state.cartelas[index]);
    this.forceUpdate();
  }
  removeCarrinho(index) {
    this.state.carrinho.splice(index,1);
    this.forceUpdate();
  }

  fazerPedido = async (e) => {
    this.state.carrinho.map((item,index) => {

      this.state.lote.cartelas.splice(this.state.lote.cartelas.indexOf(item),1);
    });
    const loteId = this.state.lote._id

    this.setState({buy: true})

    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });

      const response = await axiosInstance.post("lotes/atualizar-lote", {
        _id: this.state.lote._id,
        cartelas: this.state.lote.cartelas
      });

      this.setState({lote : response.data})
    } catch (err) {
      console.log(err);
    }

    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });


      const {data} = await axiosInstance.post(
        "pedidos/fazer-pedido-cliente",
        {
          cartelas: this.state.carrinho,
          loteId: loteId,
          clienteId: this.state.user._id,
          // cambistaId: this.state.user.tutorId,
          data: new Date(),
          codigo : '',
          status: true
        }


      );
      if(data){
        setTimeout(() => {
          window.location.href = '/minhas-cartelas';
        },5000)

      }
    } catch (err) {
      console.log(err);
    }

  };

  ordenaCartelas (a, b) {
    if (a.codigo > b.codigo) {
      return 1;
    }
    if (a.codigo < b.codigo) {
      return -1;
    }

    return 0;

  }

  removeDuplicada(){
    var car = [...this.state.carrinho.sort(this.ordenaCartelas)];
    var carrinho = this.state.carrinho.sort(this.ordenaCartelas);
    carrinho.map((cartela,index) => {
        var lastItem = car[index-1];
        var nextItem = car[index+1];
        if(car[index] != undefined && lastItem != undefined){
            if(car[index].codigo == lastItem.codigo){
                car.splice(index,1);
            }
        }
        if(car[index] != undefined && nextItem != undefined){ {
          if(car[index].codigo == nextItem.codigo){
            car.splice(index,1);
          }
        }
    }
    })
    this.setState({carrinho: car.sort(this.ordenaCartelas)})
    this.fazerPedido()
  }
  comprarPedido(e){
    setTimeout(() => {
      e.target.disabled = true;
      if(this.state.carrinho.length > 0){
      this.removeDuplicada()
      this.setState({clicked: true})
  
      }
      else{
        alert("Selecione alguma cartela para fazer o pedido.")
      }

    }, 1000)

    //alert("Obrigado pela compra, acompanhe seu pedido na aba (MINHAS CARTELAS) ou continue comprando!")
    //window.location.reload()
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });

      if(this.state.user.endereco == undefined || this.state.user.endereco == '' ){
        this.props.history.push('/preencher-cadastro')
      }
    } catch (err) {
      console.log(err);
    }
  };

  cartelasLoja = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("lotes/cartelas-loja", {});
      // this.setState({ lotes: response.data });
      // this.setState({ lote: this.state.lotes[Math.floor(Math.random() * this.state.lotes.length)] });
      this.setState({ lote: response.data });
      console.log(this.state.lote)
      if(!this.state.lote){
        window.location.reload()
      }
      var index =  Math.floor(Math.random() * (this.state.lote.cartelas.length - 10)) +
      1;
        
      this.setState({
        cartelas: this.state.lote.cartelas.slice(index, index + 10)
      });

    } catch (err) {
      console.log(err);
    }
  };

  selecionar(event) {
    setTimeout(() => {
    //REMOVE
    if (
      event.target.name > -1 &&
      document
        .getElementById("item-" + event.target.name)
        .classList.contains("selecionado")
    ) {
      document
        .getElementById("item-" + event.target.name)
        .classList.remove("selecionado");
      document
        .getElementById("sel-tit-" + event.target.name)
        .classList.add("collapse");
      this.removeCarrinho(event.target.name);
    }
    //ADD
    else if (
      event.target.name > -1 &&
      !document
        .getElementById("item-" + event.target.name)
        .classList.contains("selecionado")
    ) {
      document
        .getElementById("item-" + event.target.name)
        .classList.add("selecionado");
      document
        .getElementById("sel-tit-" + event.target.name)
        .classList.remove("collapse");
      this.addCarrinho(event.target.name);
    }
    },800)

  }

  async statusVenda(){
    try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.get("parametros/venda-status", {});
        this.setState({statusVenda : response.data})
      } catch (err) {
        console.log(err);
      }
}


formatDate(data) {
return moment(data).add(0,'days').format('DD-MM-YYYY')
}

checkAll(e){
  this.state.carrinho = [];
  if(!this.state.checkAll){

    this.state.cartelas.map((cartela,index) => {
      this.addCarrinho(index)
      document
      .getElementById("item-" + index)
      .classList.add("selecionado");
      document
      .getElementById("sel-tit-" + index)
      .classList.remove("collapse");
    })

  }
  else{
    this.state.cartelas.map((cartela,index) => {
      this.removeCarrinho(index);
    document
    .getElementById("item-" + index)
    .classList.remove("selecionado");
  document
    .getElementById("sel-tit-" + index)
    .classList.add("collapse");

})
  }

  this.setState({checkAll : !this.state.checkAll})

}
async  reload(){
  await window.location.reload()
}

render() {


     const removeToggled = (e) => {
         window.localStorage.setItem("rotaAtual", e.target.name);
         setTimeout(this.reload, 1000)
     }
     const logout = () => {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem("rotaAtual");
      window.location.href = '/'
  }
 
    const  screenWidth = this.state.screenWidth >= 960? 3 : 1;
    var settings = {
      dots: true,
      infinite: false,
      speed: 1,
      slidesToShow : screenWidth ,
      slidesToScroll: 1,
    };
    return (
      <div>
        <div class="wrapper">
          <div class="sidebar" data-image="/assets/img/sidebar-5.jpg">
            <div class="sidebar-wrapper">
              <div class="logo">
                <img src={Logo} style={{ width: "10em", height: "4em" }} />
              </div>

              <ul class="nav">
              <li class="nav-item">
                <Link onClick={logout} className="nav-link" >
                    <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                  </Link>
                </li>
                <li class="nav-item">
                  <Link class="nav-link" to="minhas-cartelas" name="minhas-cartelas" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-layers-3"></i>
                    <p>Minhas cartelas</p>
                  </Link>
                </li>
                <li class="nav-item active">
                  <Link class="nav-link" to="loja-cliente" name="loja-cliente" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-istanbul"></i>
                    <p>Loja</p>
                  </Link>
                </li>
                <li>
                  <Link class="nav-link" to="ganhadores" name="ganhadores" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-satisfied"></i>
                    <p>ult. ganhadores</p>
                  </Link>
                </li>
                <li>
                  <Link class="nav-link" to="perfil-cliente" name="perfil-cliente" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-circle-09"></i>
                    <p>Perfil</p>
                  </Link>
                </li>
                <li style={{padding: '8px'}}>
                  <a style={{border: '3px solid white', borderRadius: '6px'}} class="nav-link"  name="aplicativo"  href="https://www.sorteflash.com/download/sorteflash-app.apk">
                    <i class="fa fa-android"></i> 
                    <p>_Aplicativo</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="main-panel">
            <nav class="navbar navbar-expand-lg " color-on-scroll="500">
              <div class="container-fluid">

                <Link class="navbar-brand d-flex" to="#">
                  {" "}
                  Loja{" "}

                </Link>

                <button
                  to=""
                  class="navbar-toggler navbar-toggler-right"
                  type="button"
                  data-toggle="collapse"
                  aria-controls="navigation-index"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-bar burger-lines"></span>
                  <span class="navbar-toggler-bar burger-lines"></span>
                  <span class="navbar-toggler-bar burger-lines"></span>
                </button>
                <div
                  class="collapse navbar-collapse justify-content-end"
                  id="navigation"
                >
                  <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                      <Link class="nav-link">
                          <span class="no-icon">{window.screen.width >= 600? "Olá, " + this.state.user.perfil.toLowerCase() + " " + this.state.user.nome : "Olá, " + this.state.user.nome }</span>
                      </Link>
                    </li>
                    {/* <li class="nav-item">
                      <Link class="nav-link" onClick={this.logout}>
                        <span class="no-icon">Sair</span>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            <div class="content">
             
            {this.state.buy? <CircularDeterminate max={100} compra={true}></CircularDeterminate> : ""}

              {(!this.state.statusVenda && this.state.user.status)? 

              <div class="container-fluid">
                {/* <div class="form-check form-check-inline">
                  <input className="ml-2 mt-2 form-check-input" type="checkbox" onChange={this.checkAll.bind(this)} value={this.state.checkAll} id="defaultCheck1" />
                  <label className="font-weight-bold form-check-label" for="defaultCheck1">Selecionar todas</label>
                </div> */}

                <div className="form-check d-flex align-items-center">
                                    <label className="form-check-label">
                                        <input id='teste' className="form-check-input"
                                               name="selecionaTodas"
                                               type="checkbox"
                                               onChange={this.checkAll.bind(this)}
                                               value={this.state.checkAll|| false}
                                               checked={this.state.checkAll|| false}/>
                                        <span className="form-check-sign"></span>
                                    </label>
                                    <label htmlFor="teste" className='mb-0'>Selecionar todas</label>
                                </div>

                <Slider class="p-5 w-100 "  {...settings}>
                  {this.state.cartelas != null
                    ? this.state.cartelas.map((item, index) => {
                        return (
                          <button
                            class="superContainer p-2"
                            onClick={this.selecionar}
                            name={index}
                            key={index}
                          >
                            <div
                              id={"item-" + index}
                              class="card text-white bg-dark mb-3 shadow"
                            >
                              <div class="bg-dark card-header ">
                                <div class="container ">
                                  <div class="row">
                                    <div class="col">
                                      <div class="row">
                                        <span class="font-weight-bold">
                                          código : <Link class="text-danger">{item.codigo}</Link>
                                        </span>
                                      </div>
                                      <div class="row">
                                        <span class="font-weight-bold text-warning">
                                          Data do sorteio : <Link class="text-light">{this.formatDate(item.data)}</Link>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="row justify-content-end">
                                        <span class="font-weight-bold">
                                          lote: <Link class="text-danger">{this.state.lote.codigo}</Link>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="bg-dark card-body justify-content-center ajustar">
                                <div
                                  class="bg-light rounded"
                                  style={{ width: "17.8em", height: "10em" }}
                                >
                                  <div class="container text-dark tracado">
                                    <div class="row">
                                      <div class="col">
                                        <span>{item.numeros[0]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[1]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[2]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[3]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[4]}</span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col">
                                        <span>{item.numeros[5]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[6]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[7]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[8]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[9]}</span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col">
                                        <span>{item.numeros[10]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[11]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[12]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[13]}</span>
                                      </div>
                                      <div class="col">
                                        <span>{item.numeros[14]}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <span
                              id={"sel-tit-" + index}
                              class="collapse font-weight-bold text-success"
                            >
                              Selecionado
                            </span>
                          </button>
                        );
                      })
                    : ""}
                </Slider>
                <div class="mt-5 container">
                  <div class="row borda">
                    <div class="col justify-content-center text-center">
                      <span class="font-weight-bold text-dark">
                        Quantidade:
                      </span>{" "}
                      <span>{this.state.carrinho.length}</span>
                    </div>
                    <div class="col justify-content-center">
                      <div class="row justify-content-center">
                        <span class="font-weight-bold text-dark">Valor:</span>{" "}
                      </div>
                      <div class="row justify-content-center">
                        <span>R$: {this.state.lote? this.state.lote.cartelas? this.state.lote.cartelas.length > 0? this.state.lote.cartelas[0].valor : '0.00' : '0.00' : '0.00'}</span>
                      </div>
                    </div>
                    <div class="col justify-content-center">
                      <div class="row justify-content-center">
                        <span class="font-weight-bold text-dark">Total: </span>{" "}
                      </div>
                      <div class="row justify-content-center">
                        <span> R$ : {this.state.lote? this.state.lote.cartelas? this.state.lote.cartelas.length > 0 ? (this.state.carrinho.length * (this.state.lote? this.state.lote.cartelas[0].valor: 0)).toFixed(2) : '0.00' : '0.00' : '0.00' }</span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col justify-content-center text-center">
                      <button disabled={this.state.clicked}
                        onClick={this.comprarPedido.bind(this)}
                        class="w-50 btn btn-success bg-success text-light"
                      >
                        COMPRAR
                      </button>
                    </div>
                  </div>
                </div>
              </div> : <div class="text-center bg-dark text-warning p-3 rounded"><h3>Desculpe, no momento não estamos vendendo!</h3></div> }
            </div>
            <footer class="footer">
              <div class="container-fluid">
                <nav>
                  <ul class="footer-menu">
                    <li>
                      <Link to="#">Empresa</Link>
                    </li>
                    <li>
                      <Link to="#">Regulamento</Link>
                    </li>
                    <li>
                      <Link to="#">Outros projetos</Link>
                    </li>
                  </ul>
                  <p class="copyright text-center">
                    Proprietário ©
                    <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                  </p>
                </nav>
              </div>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default LojaCliente;
